module.exports = __webpack_public_path__ + "img/TRANSPORTS_ACTIVE.679f0e24.svg";